<section id="cushion">
    <div class=shoe-type>
        <h2 tabindex="0">Cushion</h2>
        <p tabindex="0">Soft, squishy, and built to last! High cushioned trainers prioritize soft and reducing ground impact over speed and rigid stability, but that doesn't mean they can't handle the occasional speed workout! These shoes are ideal for people who want a smooth, soft, and comfortable ride and potentially looking to run longer mileage.</p>
        <div class="check-out">
            <h3 tabindex="0">Be sure to check out...</h3>
            <div class="row">
                <ng-container *ngFor="let shoe of cushionShoes">
                    <div class="col-lg-4">
                        <app-shoe-card [shoe]="shoe"></app-shoe-card>         
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section>